export default {
    product: {
        category: "กาแฟ ชา และเครื่องดื่ม", vatIncluded: "รวม VAT", add: "เพิ่ม", added: "เพิ่มแล้ว",
        favorite: "เพิ่ม {{name}} ในรายการโปรด", badgePitango: "สินค้า PITANGO", badgePopular: "ยอดนิยม",
        detailTitle: "รายละเอียดสินค้า", priceUnavailable: "สำหรับราคา โปรดติดต่อฝ่ายลูกค้า", bundleOffer: "{{quantity}} ชิ้น {{price}}", percentOffer: "ลด {{percent}}%",
        callCustomerSupportForPrices: "สำหรับราคา โปรดติดต่อฝ่ายลูกค้า", notFound: "ไม่พบสินค้า"
    },
    cart: {
        title: "ตะกร้าของคุณ", empty: "ตะกร้าของคุณว่าง", subtotal: "ยอดรวมย่อย", total: "ยอดรวม", shipping: "ค่าจัดส่ง", shippingFree: "ฟรี",
        checkout: "ดำเนินการชำระเงิน", remove: "นำ {{name}} ออกจากตะกร้า", addedTitle: "เพิ่มลงตะกร้าแล้ว",
        addedMessage: "ตะกร้าของคุณได้รับการอัปเดตแล้ว", viewCart: "ดูตะกร้า", updateError: "ไม่สามารถอัปเดตตะกร้าได้ โปรดลองอีกครั้ง",
        unitPrice: "ราคาปกติ: {{price}} ต่อชิ้น", promotion: "ใช้โปรโมชั่นแล้ว", bundleBreakdown: "ราคาโปรโมชั่น × {{bundles}} · สินค้าในโปรโมชั่น: {{units}}",
        remainderBreakdown: "อีก {{units}} ชิ้นในราคาปกติ", discountedUnits: "ส่วนลดสำหรับ {{units}} ชิ้น",
        regularTotal: "ราคาก่อนโปรโมชั่น", youSave: "ประหยัด", itemTotal: "รวมรายการ",
        addMoreForPromotion: "เพิ่มอีก {{units}} ชิ้นเพื่อรับโปรโมชั่น {{offer}}",
        promotionExtraCost: "เพิ่มเพียง {{amount}}", promotionLowersTotal: "ยอดรวมจะลดลง {{amount}}",
        addPromotionUnits: "เพิ่ม {{units}}"
    }
} as const;
